/**
 * 简单校验邮箱
 * @param email
 * @returns {boolean}
 */
function isEmail(email) {
  return /\w+@\w+\.\w+/.test(String(email))
}

/**
 * 简单校验手机号
 * @param phone
 * @returns {boolean}
 */
function isPhone(phone) {
  return /^1[3-9]\d{9}$/.test(String(phone))
}

/**
 * 简单校验银行卡
 * @param bankCard
 * @returns {boolean}
 */
function isBankCard(bankCard) {
  return /^(\d{16,19})$/.test(String(bankCard))
}
/**
 * 简单校验身份证
 * @param isIdCard
 * @returns {boolean}
 */
function isIdCard(bankCard) {
  return /(^\d{15}$)|(^\d{17}[xX]$)|(^\d{18}$)/.test(String(bankCard))
}
export {
  isEmail,
  isPhone,
  isBankCard,
  isIdCard
}



// WEBPACK FOOTER //
// ./src/libs/ValidateUtils.js